<template>
  <div class="form-page-wrapper">
    <div style="width: 500px">

      <el-form :model="form" :rules="rules" :hide-required-asterisk="true" ref="form"  >
        <el-form-item prop="appName">
          <template v-slot:label>
            <div class="form-item__label">应用名称</div>
          </template>
          <el-input v-model="form.appName"  placeholder="应用名称" />
        </el-form-item>
        <el-form-item prop="appBundle">
          <template v-slot:label>
            <div class="form-item__label">应用包名</div>
          </template>
          <el-input v-model="form.appBundle"  placeholder="应用包名" />
        </el-form-item>
        <el-form-item prop="appType">
          <template v-slot:label>
            <div class="form-item__label">应用类型</div>
          </template>
          <div style="display: inline-block; width: 100%">
            <el-radio v-model="form.appType" :label="1">安卓</el-radio>
            <el-radio v-model="form.appType" :label="2">苹果</el-radio>
          </div>
        </el-form-item>
        <el-form-item prop="appUrl">
          <template v-slot:label>
            <div class="form-item__label">下载地址</div>
          </template>
          <el-input v-model="form.appUrl"  placeholder="下载地址" />
        </el-form-item>
        <el-form-item prop="appDesc">
          <template v-slot:label>
            <div class="form-item__label">应用简介</div>
          </template>
          <el-input v-model="form.appDesc" type="textarea" placeholder="应用简介" />
        </el-form-item>
      </el-form>

      <div style="text-align: center;">
        <el-button @click="toPage" >返回</el-button>
        <el-button @click="submit" type="primary" >提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import { addAdChannelApp, updateAdChannelApp, getAdChannelAppDetail } from '@/api/advertise/app'

export default {
  data () {
    return {
      form: {
        appId: undefined,
        appName: undefined,
        appBundle: undefined,
        appType: 1,
        appUrl: undefined,
        appDesc: undefined
      },
      rules: {
        appName: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        appBundle: [
          { required: true, message: '请输入应用包名', trigger: 'blur' }
        ],
        appUrl: [
          { required: true, message: '请输入下载地址', trigger: 'blur' }
        ],
        appDesc: [
          { required: true, message: '请输入应用简介', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getAdChannelAppDetail()
  },
  methods: {
    getAdChannelAppDetail () {
      if (!this.$route.query.appId) return
      getAdChannelAppDetail({ appId: this.$route.query.appId }).then(res => {
        if (res.code === 200) {
          this.form = res.data
        }
      })
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.appId) {
            addAdChannelApp(this.form).then(res => {
              if (res.code === 200) {
                this.resetForm()
                this.toPage()
              }
            })
          } else {
            updateAdChannelApp(this.form).then(res => {
              if (res.code === 200) {
                this.resetForm()
                this.toPage()
              }
            })
          }
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
      this.form = {
        slotId: undefined,
        slotName: undefined,
        slotTypeId: undefined,
        appId: undefined,
        slotDesc: undefined
      }
    },
    toPage () {
      this.$router.push({ path: 'list' })
    }
  }
}
</script>

<style>
  .form-page-wrapper{
    padding: 20px;
    background: #ffffff;
  }
  .form-label{
    display: block;
    line-height: 20px;
  }

  .form-item__label{
    line-height: 20px;
  }
</style>
